/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PastMedicalHistory from './past-medical-history';
import PastMedicalHistoryDetail from './past-medical-history-detail';
import PastMedicalHistoryUpdate from './past-medical-history-update';
import PastMedicalHistoryDeleteDialog from './past-medical-history-delete-dialog';

const PastMedicalHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PastMedicalHistory />} />
    <Route path="new" element={<PastMedicalHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<PastMedicalHistoryDetail />} />
      <Route path="edit" element={<PastMedicalHistoryUpdate />} />
      <Route path="delete" element={<PastMedicalHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PastMedicalHistoryRoutes;
